import { WEEKLY_SNAPSHOT } from "../mock/weeklySnapshot";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Mirrors the real contract: `GET /api/analytics/weekly-snapshot`.
 * Swap the body for an `api.get(...)` call when the backend exists.
 */
export async function fetchWeeklySnapshot() {
  await delay(300);
  return WEEKLY_SNAPSHOT;
}
